<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input size="medium" v-model="searchForm.tel" placeholder="请输入用户电话"  type="text" @input="searchForm.tel = String(searchForm.tel).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"  @keyup.enter.native="getTableList"></el-input>
      <el-select size="medium" clearable v-model="searchForm.roleId" @change="getTableList" placeholder="请选择角色">
        <el-option
          v-for="item in roleList"
          :key="item.roleId"
          :label="item.roleName"
          :value="item.roleId">
        </el-option>
      </el-select>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
    <div class="searchRight">
      <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
    </div>
   </div>
   <el-table
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="userName"
      label="用户姓名">
    </el-table-column>
    <el-table-column
      prop="phone"
      label="电话">
    </el-table-column>
    <!-- <el-table-column
      prop="code"
      label="性别">
      <template slot-scope="scope">
        <span>{{scope.row.sex==1?'男':scope.row.sex==2?'女':'未知'}}</span>
      </template>
    </el-table-column> -->
    <el-table-column
      prop="role.roleName"
      label="角色">
    </el-table-column>
    <el-table-column
      prop="way"
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="editType(scope.row)"><i class="el-icon-edit" style="margin-right:3px;"></i>修改</el-button>
        <el-button size="mini" type="danger" @click="deleteType(scope.row)" v-if="scope.row.id!=1"><i class="el-icon-delete" style="margin-right:3px;"></i>删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 30, 40]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
    :title="ruleForm.sysUserId?'修改账户':'添加账户'"
    :visible.sync="dialogVisible"
    width="430px">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <!-- <el-form-item label="用户名" prop="userName" :rules="rules.userName" v-if="!ruleForm.sysUserId">
            <el-input placeholder="请输入用户名" v-model="ruleForm.userName" style="width:240px"></el-input>
        </el-form-item> -->
        <el-form-item label="用户姓名" prop="userName" :rules="rules.userName">
            <el-input placeholder="请输入用户姓名" v-model="ruleForm.userName" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="userPwd" :rules="rules.userPwd" v-if="!ruleForm.sysUserId">
            <el-input type="password" placeholder="请输入用户密码" v-model="ruleForm.userPwd" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="用户电话" prop="phone" :rules="rules.phone">
            <el-input type="number" placeholder="请输入用户电话" v-model="ruleForm.phone" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="用户角色" prop="roleId" :rules="rules.selectRule">
            <el-select size="medium" clearable v-model="ruleForm.roleId" @change="getTableList" placeholder="请选择角色" style="width:240px">
              <el-option
                v-for="item in roleList"
                :disabled="item.roleId==29||item.roleId==30||item.roleId==32"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId">
              </el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item label="账户状态" prop="flag">
            <el-radio-group v-model="ruleForm.flag">
                <el-radio label="1">运行</el-radio>
                <el-radio label="2">冻结</el-radio>
            </el-radio-group>
        </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var phoneRule = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        }else {
          callback();
        }
      }
    };
    return {
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        isLoginBack:1,
        roleId:'',
      },
      tableData: [],
      dialogVisible:false,
      ruleForm:{
        sysUserId:'',
        userName:'',
        userPwd:'',
        phone:'',
        roleId:'',
        registerSource: '2',
        isLoginBack: '1'
      },
      rules:{
          userPwd: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 10, message: '密码最小为6位-10位', trigger: 'blur' }
          ],
          userName:[
              { required: true, message: '请输入', trigger: 'blur' }
          ],
          phone:[
              { required: true, validator: phoneRule, trigger: 'blur' }
          ],
          // selectRule:[
          //     { required: true, message: '请选择', trigger: 'change' }
          // ]
      },
      roleList:[],
    };
  },
  created() {
    this.getTableList()
    this.getRoleList()
  },
  methods: {
    submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
            if (valid) {
                 let ruleForm = {...this.ruleForm}
                 let roleName=this.roleList.filter(x=>x.roleId==this.ruleForm.roleId)[0].roleName
                 ruleForm.desc=`<p>${roleName}</p>`
                 let res = null
                 if(this.ruleForm.sysUserId) {
                   ruleForm.userPwd=undefined
                   res = await this.$http.adminAddUser({...ruleForm});
                 }else {
                   ruleForm.sysUserId = undefined
                   res = await this.$http.adminAddUser({...ruleForm});
                 }
                if (res) {
                  this.$message.success('操作成功！');
                  this.dialogVisible=false;
                  this.getTableList()
                }
            } else {
            console.log('error submit!!');
            return false;
            }
        });
    },
    deleteType(row){
        this.$confirm(`确定要删除${row.userName}账户吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.delUser({sysUserId:row.sysUserId});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    editType(row){
      // this.$nextTick(() => {
			// 	this.$refs['ruleForm'].resetFields()
			// })
      this.ruleForm.sysUserId=row.sysUserId;
      this.ruleForm.userName=row.userName;
      this.ruleForm.phone=row.phone;
      this.ruleForm.roleId=row.role.roleId;
      this.dialogVisible=true
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addFunc(){
      this.$nextTick(() => {
				this.$refs['ruleForm'].resetFields()
			})
      this.ruleForm={
        sysUserId:'',
        userName:'',
        userPwd:'',
        phone:'',
        roleId:'',
        registerSource: '2',
        isLoginBack: '1'
      },
      this.dialogVisible=true;
    },
    async getTableList(val){
      console.log(this.searchForm)
       let res = await this.$http.userList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum=res.data.totalSize
        }
    },
    async ChangeTypeIsflag(row){
        let res = await this.$http.updateUserFlag({userId:row.id,flag:row.flag==2?2:1});
        if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
        }
    },
    async getRoleList(){
      let res = await this.$http.roleList();
      if (res) {
      this.roleList=res.list
      }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style scoped>


</style>
